<div class="container">
  @if (isCustomisable) {
  <label
    class="checkbox-container"
    [class.disabled]="disabled"
    (click)="$event.stopPropagation()"
  >
    <input
      class="checkbox-input"
      type="checkbox"
      [ngModel]="checked"
      (ngModelChange)="onModelChange($event)"
      style="display: hidden"
    />
    <div class="checkbox" [class.selected]="checked || indeterminate">
      @if (checked && !indeterminate) {
      <img src=" assets/images/common/check.svg" />
      } @if (indeterminate) {
      <img src=" assets/images/roles/indeterminate.svg" />
      }
    </div>
  </label>
  }
  <div class="title">
    <ng-content> </ng-content>
  </div>
</div>

@if (!isCustomisable) {
<div class="cross">
  <img src="assets/images/roles/close.svg" />
</div>
}
